function getNullableNumber (value) {
  return value === 0 || value ? value : null
}

export default getNullableNumber
